import React from 'react';
import firebase from 'firebase';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { AuthContainer } from 'containers';
import configureStore from 'store';
import cognitesdk from '@cognite/cognitesdk';
import Routes from 'routes';
import 'antd/dist/antd.css';
import 'styles/global-styles';

if (process.env.REACT_APP_ENV === 'production') {
  const config = {
    apiKey: 'AIzaSyB5Sn6DnVJcB7TN2MdJMUSeh7IpZDRvYuE',
    authDomain: 'operational-intelligence.firebaseapp.com',
    databaseURL: 'https://operational-intelligence.firebaseio.com',
    projectId: 'operational-intelligence',
    storageBucket: 'operational-intelligence.appspot.com',
    messagingSenderId: '979215302883',
  };
  firebase.initializeApp(config);
} else {
  const config = {
    apiKey: 'AIzaSyArb2WMHkmsAlwKIZ6gJRiLlmS8tmO-ClI',
    authDomain: 'opint-dev.firebaseapp.com',
    databaseURL: 'https://opint-dev.firebaseio.com',
    projectId: 'opint-dev',
    storageBucket: '',
    messagingSenderId: '392729975177',
  };
  firebase.initializeApp(config);
}

// TODO: create a cognite theme that is re-usable
const theme = {};

window.Raven.config(
  'https://8b02f95802d1487e846f7d278772c655@sentry.io/273104'
).install();

const store = configureStore();

cognitesdk.configure({
  version: '0.4',
});

render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <AuthContainer>
        <Routes />
      </AuthContainer>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js